export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_MODULO_ID':
      return { ...state, idModulo: action.idModulo };
    case 'ADD_MENU_MODULO_ID':
      return { ...state, idMenu: action.idMenu };
    case 'ADD_PAGINA_MODULO_ID':
      return { ...state, idPagina: action.idPagina };
    default:
      return state;
  }
};
